import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Phone, MessageCircle, Mail } from "lucide-react";
import Logo from "@/components/brand/Logo";

const WHATSAPP = "918839790836";
const PHONE = "+918839790836";

export default function Footer() {
  return (
    <footer className="relative overflow-hidden bg-pulse-navy text-white grain-overlay" data-testid="marketing-footer">
      <div className="relative z-10 mx-auto max-w-6xl px-5 py-16 sm:px-8 sm:py-20">
        <div className="grid gap-12 md:grid-cols-[1.5fr_1fr_1fr]">
          <div>
            <h2 className="text-4xl font-bold tracking-tight sm:text-5xl">Let's talk.</h2>
            <p className="mt-4 max-w-sm text-white/60">
              Ready to bring order to your bookings? Message us on WhatsApp and we'll set you up.
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href={`https://wa.me/${WHATSAPP}`}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp"
                className="flex items-center gap-2 rounded-md bg-pulse-green px-5 py-3 text-sm font-semibold text-white transition-transform hover:scale-[1.02] active:scale-[0.97]"
              >
                <MessageCircle size={18} /> Chat on WhatsApp
              </a>
              <a
                href={`tel:${PHONE}`}
                data-testid="footer-call"
                className="flex items-center gap-2 rounded-md border border-white/20 px-5 py-3 text-sm font-semibold text-white transition-colors hover:bg-white/10"
              >
                <Phone size={18} /> Call us
              </a>
            </div>
          </div>

          <div>
            <div className="text-xs font-medium uppercase tracking-wider text-white/40">Product</div>
            <div className="mt-4 flex flex-col gap-3 text-sm text-white/70">
              <Link to="/products" className="transition-colors hover:text-white">Calendar</Link>
              <Link to="/pricing" className="transition-colors hover:text-white">Pricing</Link>
              <Link to="/about" className="transition-colors hover:text-white">About us</Link>
              <Link to="/blog" className="transition-colors hover:text-white">Blog</Link>
            </div>
          </div>

          <div>
            <div className="text-xs font-medium uppercase tracking-wider text-white/40">Connect</div>
            <div className="mt-4 flex flex-col gap-3 text-sm text-white/70">
              <a href="https://instagram.com/pulse.forbusiness" target="_blank" rel="noopener noreferrer"
                 data-testid="footer-instagram" className="flex items-center gap-2 transition-colors hover:text-white">
                <Instagram size={16} /> @pulse.forbusiness
              </a>
              <a href={`tel:${PHONE}`} className="flex items-center gap-2 transition-colors hover:text-white">
                <Phone size={16} /> +91 88397 90836
              </a>
              <a href="mailto:pulsesupport4@gmail.com" data-testid="footer-email" className="flex items-center gap-2 transition-colors hover:text-white">
                <Mail size={16} /> pulsesupport4@gmail.com
              </a>
              <Link to="/contact" className="transition-colors hover:text-white">Contact us</Link>
              <Link to="/legal" className="transition-colors hover:text-white">Privacy &amp; Terms</Link>
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 sm:flex-row sm:items-center">
          <Logo variant="light" size={24} />
          <div className="sm:text-right">
            <p className="text-xs text-white/40">© {new Date().getFullYear()} Pulse. The heartbeat of your business.</p>
            <p className="mt-1 text-xs text-white/40">A product by <span className="font-medium text-white/70">Jbros Innovation Pvt. Ltd.</span></p>
          </div>
        </div>
      </div>
    </footer>
  );
}
